export default {
  structure: {
    titreHeader: {
      title: "Logo de la Ville de Carouge",
      alt: "Ville de Carouge"
    }
  },
  message: {
    error: {
      404: {
        title: "404 - Page déplacée ou supprimée",
        msg:
          "La page que vous souhaitez consulter sur cette application n'existe pas, a été déplacée ou supprimée."
      },
      unauthorized: "Vous n'êtes pas autorisé à consulter cette page."
    },
    title: {
      line1: "Objets encombrants",
      line2: "Demande de rendez-vous",
      logo: "logo_carouge_lg.png",
      mobileLogo: "logo_carouge.png",
      stickyLogo: "logo_carouge.png",
      favIcon: "favicon_carouge.ico"
    },
    subtitle: "Sur la plateforme des démarches en ligne de la ville de Carouge",
    erreurStandard: "Une erreur est survenue, veuillez réessayer plus tard",
    erreurSession:
      "Votre session a expiré, merci de recommencer votre sélection",
    precedent: "Étape précédente",
    suivant: "Étape suivante",
    oui: "Oui",
    non: "Non",
    contact: "Contact Service Voirie, espaces verts et matériel",
    step1: {
      title: "Adresse",
      comment:
        "Merci de saisir votre adresse pour afficher le point de dépôt le plus proche de votre domicile.",
      recherchePlaceholder: "Saisir une adresse",
      iconeMaisonTexte: "Votre adresse",
      iconeDepotTexte:
        "Adresse du dépôt (si différente de l'adresse de domicile)",
      precisionLieuDepot: "Précision sur le lieu de dépôt : ",
      precisionTravaux: "Travaux en cours : ",
      orthophotoTexte: "Afficher la vue aérienne",
      erreur: {
        adresseObligatoire: "La saisie de l'adresse est obligatoire."
      }
    },
    step2: {
      title: "Date de dépôt",
      info:
        "Choisir une date - Les objets sont à déposer la veille du rendez-vous, entre 20h00 et 22h00 ou le jour du rendez-vous, avant 7h00.",
      alerteInfo: "Votre choix : ",
      legendeDisponible: "Disponible",
      legendeComplet: "Complet",
      dateNonDisponible:
        "Votre choix n'est plus disponible, merci de sélectionner une nouvelle date"
    },
    step3: {
      title: "Objets",
      info1: "Un maximum de {nbMaxObject} objets peut être déposé.",
      info2: "Pour plus d'informations, voir la page ",
      info3: '"Objets encombrants"',
      punaisesTexte:
        "Avez-vous actuellement une présence de punaises de lit dans votre immeuble ?",
      punaisesModal:{
        texte:  "Si vos déchets encombrants sont contaminés par des punaises de lit, nous vous invitons à bien vouloir nous contacter au {telephone}. <br/> Nous vous fournirons gratuitement des housses protectrices et des autocollants signalétiques, pour votre protection, celle de la population environnante, ainsi que celle de notre personnel.\n" +
            "<br/>Des instructions supplémentaires vous seront communiquées lors de votre passage à la voirie ({adresse})",
        oui: "Mes déchets encombrants sont contaminés",
        non: "Mes déchets ne sont pas contaminés (présence de punaises de lit seulement dans mon immeuble)"
      },
      alerteMin: "Vous devez choisir au moins 1 objet.",
      alerteMax: "Le nombre maximum d'objets est atteint.",
      interdits: {
        dechspec: {
          libelle: "Déchets spéciaux",
          legende:
              "Déchets spéciaux"
        },
        matelect: {
          libelle: "Matériel électrique",
          legende:
              "Matériel électrique"
        },
        electromenager: {
          libelle: "Electroménager",
          legende:
              "Electroménager"
        },
        papier: {
          libelle: "Papier et carton",
          legende:
              "Papier et carton"
        },
        batteries: {
          libelle: "Batteries",
          legende:
              "Batteries"
        },
        eclaieco: {
          libelle: "Eclairages économiques",
          legende:
              "Eclairages économiques"
        },
        gravats: {
          libelle: "Gravats",
          legende:
              "Gravats"
        },
        pneus: {
          libelle: "Pneus",
          legende:
              "Pneus"
        },
        elecburo: {
          libelle: "Electronique de bureau",
          legende:
              "Electronique de bureau"
        },
      },
      objet: {
        petitMobilier: {
          libelle: "Petit mobilier",
          legende:
            "chaise, commode, meuble bas, tabouret, armoire de toilette, etc."
        },
        grosMobilier: {
          libelle: "Gros mobilier",
          legende: "armoire, bureau, canapé, clic-clac, table, etc."
        },
        literie: {
          libelle: "Literie",
          legende: "cadre de lit, sommier, matelas (à emballer au préalable)"
        },
        moquetteTapis: {
          libelle: "Tapis",
          legende: "en rouleau uniquement"
        },
        appareilSport: {
          libelle: "Appareil de sport",
          legende: ""
        },
        loisirVoyage: {
          libelle: "Loisir et voyage",
          legende: "jouet, valise, etc."
        },
        miroirVerre: {
          libelle: "Miroir et verre",
          legende: ""
        },
        fer: {
          libelle: "Fer",
          legende: "étagère, armoire métallique, etc."
        },
        bois: {
          libelle: "Bois",
          legende: "planche, étagère, caisse en bois"
        },
        articleCuisine: {
          libelle: "Article de cuisine",
          legende: ""
        },
        accessoireDecoration: {
          libelle: "Accessoire et décoration",
          legende: "bac à fleurs, tringle à rideaux, tableau, etc."
        },
        divers: {
          libelle: "Objets divers",
          legende:
            "poussette, siège enfant, parasol, échelle, étendoir à linge, etc."
        },
        canape: {
          libelle: "Canapé",
          legende: ""
        },
        sapin: {
          libelle: "Sapin",
          legende: ""
        }
      }
    },
    step4: {
      title: "Contact",
      nom: "Nom",
      prenom: "Prénom",
      noTel: {
        libelle: "Numéro de téléphone",
        placeholder: "Ex : 022 123 45 67 ou 079 123 45 67"
      },
      email: "Adresse e-mail",
      erreur: {
        nomObligatoire: "La saisie du Nom est obligatoire.",
        prenomObligatoire: "La saisie du Prénom est obligatoire.",
        emailObligatoire: "La saisie d'une adresse e-mail est obligatoire.",
        formatNonValide: "Format non valide.",
        longueur1: "Maximum 10 caractères.",
        longueur2: "Maximum 30 caractères.",
        longueur3: "Maximum 100 caractères."
      },
      champsRequis: "Champs requis *"
    },
    step5: {
      title: "Vérification",
      info1: "Vos informations sont-elles correctes ?",
      info2:
        "Pensez à bien vérifier votre adresse e-mail, indispensable pour la validation de votre rendez-vous.",
      adresse: "Adresse",
      lieuDepot: "Lieu de dépôt",
      travaux: "Travaux en cours",
      dateChoisie: "Date choisie",
      lienModifier: "Modifier",
      punaises1: "Vous avez précisé que des punaises de lit sont présentes dans votre immeuble. Il est obligatoire d’emballer tout objet contaminé. Merci de venir chercher gratuitement des housses protectrices et autocollants signalétiques avant de déposer vos articles sur le domaine public au {nom} - {adresse}. Renseignez-vous au {telephone}.",
      certification1:
        "En cochant cette case, je certifie que ma demande est effectuée à titre privé et ne concerne ni une entreprise, ni un commerce, ni une association, ni toute autre activité professionnelle et atteste avoir pris connaissance des informations relatives aux débarras des encombrants disponibles sur le",
      certification2: "site de la Ville de Carouge",
      erreur:
        "Une erreur est survenue, impossible de valider votre rendez-vous, veuillez réessayer plus tard.",
      limite:
        "Vous ne pouvez pas effectuer plus d'une réservation en l'espace d'une semaine.<br>" +
        "Vous avez déjà validé au moins une autre réservation dans la même période.<br>" +
        "Merci de bien vouloir choisir une autre date.",
      dejaSupprime: "Ce rendez-vous a déjà été supprimé."
    },
    step6: {
      title: "Confirmation",
      info1:
        "Merci de valider définitivement votre demande à l'aide de l'e-mail qui vous a été envoyé.",
      info3:
          "Vous n'avez pas reçu d'e-mail ? Vérifiez vos courriers indésirables (Spam).",
      info4: "Vous trouverez plus de renseignements sur le ",
      info5: "site de la Ville de Carouge"
    },
    step7: {
      validationOk:
        "Merci, votre demande de rendez-vous pour un débarras d'encombrants a bien été validée.",
      info1:
          "Un courriel avec le détail de votre rendez-vous ainsi qu'un numéro de réservation à annoncer en cas de contrôle vous a été envoyé.",
      info2:
          "Vous n'avez pas reçu d'e-mail ? Vérifiez vos courriers indésirables (Spam).",
      rejetOk:
        "Merci pour votre signalement, la demande de rendez-vous pour un débarras d'encombrants a été annulée.",
      erreur: "Votre demande n'a pas pu être prise en compte.",
      dejaValide: "La réservation a déjà été validée.",
      dejaRejete: "La réservation a déjà été rejetée.",
      sessionExpiree: "Votre session a expiré.",
      messageErreur:
        "Une erreur est survenue, merci de recommencer votre demande."
    },
    verification: {
      modification: "Vous avez demandé la modification de votre rendez-vous.",
      suppression: "Vous avez demandé la suppression de votre rendez-vous.",
      info:
        "Avant de poursuivre, veuillez saisir le numéro de réservation qui vous a été attribué par e-mail :",
      numero: {
        libelle: "Numéro de réservation",
        erreur: {
          obligatoire: "La saisie du numéro de réservation est obligatoire."
        }
      },
      erreur: {
        numero: "Numéro incorrect.",
        modification: "Ce rendez-vous ne peut pas être modifié.",
        suppression: "Ce rendez-vous ne peut pas être supprimé."
      }
    },
    validation: {
      confirmation:
        "Veuillez cliquer sur le bouton valider ci-dessous afin de finaliser votre rendez-vous.\n" +
        "Si vous n'avez pas fait de demande ou que vous avez changé d'avis, cliquez sur annuler.",
      button: {
        confirmation: "Valider ma demande de rendez-vous",
        reject: "Annuler la demande"
      },
      messageErreur:
        "Une erreur est survenue, merci de recommencer votre demande."
    },
    suppression: {
      info: "Voulez-vous vraiment supprimer votre rendez-vous ?",
      ok: "Votre rendez-vous a bien été supprimé.",
      erreur: "Une erreur est survenue, merci de recommencer ultérieurement."
    }
  }
};
